//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import getDirectoriesRandomFiles from '~/pages/sandbox/Helpers/GetDirectoriesRandomFiles'
import getFirstImageDimension from '~/pages/sandbox/Helpers/GetFirstImageDimension'
import getImageFromFile from '~/pages/sandbox/Helpers/GetImageFromFile'
import { artworkMaxWidth, artworkCount } from '~/pages/sandbox/Helpers/Config'
import { UploadFiles, uploadSample } from '~/pages/sandbox/Helpers/UploadFiles'
import DotError from '~/components/projects/DotError'

export default {
  name: 'SandboxTag',
  version: '202207081525',
  components: {
    DotError,
  },

  props: {
    project: {
      type: Object,
      default: () => ({}),
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      uploadText: 'Click to select your artwork folder',
      dirHandle: null,
      supportedBrowser: null,
      artworks: [],
      artCount: artworkCount,
      error: '',
      fileUpload: {
        current: null,
        total: 0,
      },
      file: null,
      selectedItem: null,
      dialog: false,
      composition: [],
      showWeight: false,
      sampleImageSize: {
        width: 250,
        height: 0,
      },
      makeChange: false,
    }
  },
  computed: {
    disableButton() {
      return this.fileUpload.total === 0
    },
    errorMessage() {
      return this.error
    },
    uploadPercent() {
      return this.fileUpload.current
        ? (this.fileUpload.current * 100) / this.fileUpload.total
        : null
    },
  },
  async mounted() {
    const tokens = []
    for (const token in this.project.SampleTokens) {
      if (tokens.length >= this.artCount) break

      tokens.push(this.project.SampleTokens[token])
    }
    this.artworks = tokens

    if (this.$route.query.artwork !== undefined) {
      if (this.$store.state.artwork.dirHandle !== null) {
        this.dirHandle = this.$store.state.artwork.dirHandle
        const sandboxArtworks = this.$store.state.artwork.artwork

        for (let i = 0; i < artworkCount; i++) {
          this.artworks[i].link = sandboxArtworks[i].link
          this.artworks[i].composition = sandboxArtworks[i].composition
          this.artworks[i].height = sandboxArtworks[i].height
        }
        const files = await getDirectoriesRandomFiles(this.dirHandle)
        this.fileUpload.total = files.length

        this.uploadArtworkFromSandbox()
        this.uploadContent()
        this.$store.commit('artwork/SET_DIR_HANDLE', null)
        this.$store.commit('artwork/SET_ARTWORK', null)
      }
    }
  },
  methods: {
    async chooseFolder() {
      try {
        this.dirHandle = await window.showDirectoryPicker()
        await this.refresh()
      }catch (e) {

      }
    },
    dropImage(e, index) {
      this.fileToDataUrl(e.dataTransfer.files[0], index)
    },
    item(index) {
      this.selectedItem = index
      document.getElementById('sampleFile').click()
    },
    getFileFromInput() {
      this.fileToDataUrl(this.file, this.selectedItem)
      this.file = null
      document.getElementById('sampleFile').value = null
    },
    fileToDataUrl(file, index) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = async () => {
        const dimension = await getFirstImageDimension(file)
        this.artworks[index].height = Math.round(
          dimension.height / (dimension.width / 250)
        )
        this.artworks[index].link = reader.result
        this.artworks[index].composition = null
        uploadSample(this.artworks[index], this.project.id, this.$axios)
      }
    },
    cleanDirectoryName(name) {
      const ar = name.split('_')
      ar.splice(0, 1)
      return ar.join(' ')
    },
    cleanFileName(str) {
      let re
      // remove option num and leading _
      re = /^([0-9]+)_/
      str = str.replace(re, '')
      // remove weight file time (.png from end of string)
      re = /_([0-9]+)\.[a-z]+$/
      str = str.replace(re, '')
      // replace _ & - with spaces, trim outer whitespace
      re = /[_-]+/g
      str = str.replace(re, ' ').trim()

      re = /\.[a-z]+$/
      str = str.replace(re, '')

      // CamelCase the remaining string
      str = this.toTitleCase(str)
      return str
    },
    toTitleCase(str) {
      return str
        .toLowerCase()
        .split(' ')
        .map(function (word) {
          return word.charAt(0).toUpperCase() + word.slice(1)
        })
        .join(' ')
    },
    uploadArtworkFromSandbox() {
      for (let i = 0; i < this.artworks.length; i++) {
        uploadSample(this.artworks[i], this.project.id, this.$axios)
      }
    },
    async refresh() {
      this.error = ''

      for (let i = 0; i < artworkCount; i++) {
        await this.generate(i)
      }
    },
    async generate(i) {
      try {
        const files = await getDirectoriesRandomFiles(this.dirHandle)

        if (files.length === 0) {
          throw new Error(`Folder is empty. Folders must contain at least one directory with one image.  Please fix this issue and try again.`);
        }
        this.fileUpload.total = files.length

        if (files.length > 0) {
          const dimension = await getFirstImageDimension(files[0])

          const type = files[0].type

          const canvas = document.createElement('canvas')
          canvas.width = artworkMaxWidth
          canvas.height = Math.round(
            dimension.height / (dimension.width / canvas.width)
          )

          const ctx = canvas.getContext('2d')

          const composition = []
          for (const file of files) {
            composition.push({
              parent: this.cleanDirectoryName(file.parent),
              file: this.cleanFileName(file.name),
            })
            const image = await getImageFromFile(file)
            ctx.drawImage(image, 0, 0, canvas.width, canvas.height)
          }

          this.artworks[i].link = canvas.toDataURL(type)
          this.artworks[i].composition = composition
          this.artworks[i].height = Math.round(
            dimension.height / (dimension.width / 250)
          )

          uploadSample(this.artworks[i], this.project.id, this.$axios)

          canvas.remove()
        }
      } catch (e) {
        this.error = e.message
      }
    },
    uploadContent() {
      this.error = ''

      if (this.fileUpload.total > 0) {
        const observable = UploadFiles(
          this.dirHandle,
          this.artworks,
          this.project.id,
          this.$axios
        )
        observable.subscribe({
          next: (x) => {
            this.fileUpload.current = x
          },
          error: (e) => {
            console.error('Error uploading', e);
            let message = 'Error uploading files';
            if (e?.message){
              message = e.message;
            }
            if (e?.response?.data?.message){
              message = e.response.data.message;
            }

            this.error = message + '  Please try again or contact support.'
          },
          complete: () => {
            // eslint-disable-next-line no-unused-expressions
            this.$emit('pushLayer')
            this.fileUpload.current = null
            this.fileUpload.total = 0
            // this.dirHandle = null
            this.uploadText = 'click to replace your artwork folder'
          },
        })
      }
    },
  },
}
